import React from "react";
import { bool, func } from "prop-types";
import {  Modal,Button } from 'react-bootstrap';
import { connect } from "react-redux";
import { hideModal, removeModal } from "../../redux/ducks/modals";


const AddNewTournamentModal = ({ show, handleHideModal, handleRemoveModal }) => (
  <Modal
    show={show}
    onHide={handleHideModal}
    onExited={handleRemoveModal}
    backdropClassName="modal-backdrop"
    // className="asset-modal"
  >
    <form>
      <Modal.Header closeButton>
        <Modal.Title>Add New Tournament</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="panel panel-default">
    <div className="panel-heading" />
    <div className="panel-body">
        <form id="example-form" action="#">
            <div>
                <h4>
                    Account
                    <br />
                    <small>Nam egestas, leo eu gravida tincidunt</small>
                </h4>
                <fieldset>
                    <label htmlFor="userName">User name *</label>
                    <input id="userName" name="userName" type="text" className="form-control required" />
                    <label htmlFor="password">Password *</label>
                    <input id="password" name="password" type="text" className="form-control required" />
                    <label htmlFor="confirm">Confirm Password *</label>
                    <input id="confirm" name="confirm" type="text" className="form-control required" />
                    <p>(*) Mandatory</p>
                </fieldset>
                <h4>
                    Profile
                    <br />
                    <small>Nam egestas, leo eu gravida tincidunt</small>
                </h4>
                <fieldset>
                    <label htmlFor="name">First name *</label>
                    <input id="name" name="name" type="text" className="form-control required" />
                    <label htmlFor="surname">Last name *</label>
                    <input id="surname" name="surname" type="text" className="form-control required" />
                    <label htmlFor="email">Email *</label>
                    <input id="email" name="email" type="text" className="form-control required email" />
                    <label htmlFor="address">Address</label>
                    <input id="address" name="address" type="text" className="form-control" />
                    <p>(*) Mandatory</p>
                </fieldset>
                <h4>
                    Hints
                    <br />
                    <small>Nam egestas, leo eu gravida tincidunt</small>
                </h4>
                <fieldset>
                    <p className="lead text-center">Almost there!</p>
                </fieldset>
                <h4>
                    Finish
                    <br />
                    <small>Nam egestas, leo eu gravida tincidunt</small>
                </h4>
                <fieldset>
                    <p className="lead">One last check</p>
                    <div className="checkbox c-checkbox">
                        <label>
                            <input type="checkbox" required="required" name="terms" />
                            <span className="fa fa-check" />I agree with the Terms and Conditions.
                        </label>
                    </div>
                </fieldset>
            </div>
        </form>
    </div>
</div>
<div className="panel panel-default">
    <div className="panel-heading">Basic Vertical Example</div>
    <div className="panel-body">
        <div id="example-vertical">
            <h4>Keyboard</h4>
            <section>
                <p>Try the keyboard navigation by clicking arrow left or right!</p>
            </section>
            <h4>Effects</h4>
            <section>
                <p>Wonderful transition effects.</p>
            </section>
            <h4>Pager</h4>
            <section>
                <p>The next and previous buttons help you to navigate through your content.</p>
            </section>
        </div>
    </div>
</div>
</Modal.Body>
      <Modal.Footer>
        <Button onClick={handleHideModal} bsStyle="primary">
          Cancel
        </Button>
        <Button bsStyle="success">Add</Button>
      </Modal.Footer>
    </form>
  </Modal>
);

AddNewTournamentModal.propTypes = {
  show: bool,
  handleHideModal: func,
  handleRemoveModal: func,
};

const mapDispatchToProps = dispatch => ({
  handleHideModal: () => {
    dispatch(hideModal("ADD_NEW_TOURNAMENT"));
  },
  handleRemoveModal: () => {
    dispatch(removeModal("ADD_NEW_TOURNAMENT"));
  },
});

export default connect(null, mapDispatchToProps)(AddNewTournamentModal);



// WEBPACK FOOTER //
// ./src/components/modals/AddNewTournamentModal.js